import React from "react";
import { useNavigate } from "react-router-dom";
import { Clock, MapPin, Heart } from "lucide-react";
import { RatingPill, VegDot, OfferBadge } from "@/components/common";
import { inr } from "@/lib/api";

export function RestaurantCard({ r, wide, onFav, faved }) {
  const nav = useNavigate();
  const closed = r.is_open === false;
  return (
    <div
      onClick={() => nav(`/restaurant/${r.id}`)}
      className={`${wide ? "w-full" : "min-w-[260px] w-[260px]"} snap-start-m cursor-pointer group`}
      data-testid={`restaurant-card-${r.id}`}
    >
      <div className="relative rounded-2xl overflow-hidden">
        <img src={r.image} alt={r.name} loading="lazy" className={`w-full ${wide ? "h-40" : "h-36"} object-cover group-hover:scale-105 transition-transform duration-500`} />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
        {r.offer && <div className="absolute top-2 left-2"><OfferBadge>{r.offer}</OfferBadge></div>}
        {closed && <div className="absolute inset-0 bg-black/50 flex items-center justify-center"><span className="text-white font-bold text-sm bg-black/50 px-3 py-1 rounded-full">Closed</span></div>}
        {onFav && (
          <button onClick={(e) => { e.stopPropagation(); onFav(r.id); }} className="absolute top-2 right-2 w-8 h-8 rounded-full bg-white/90 flex items-center justify-center tap" data-testid={`fav-${r.id}`}>
            <Heart size={16} className={faved ? "fill-nonveg text-nonveg" : "text-ink-600"} />
          </button>
        )}
        <div className="absolute bottom-2 left-2 text-white text-[11px] font-semibold flex items-center gap-1">
          <Clock size={12} /> {r.delivery_time_min} min
        </div>
      </div>
      <div className="pt-2">
        <div className="flex items-center justify-between gap-2">
          <h3 className="font-bold text-ink text-[15px] truncate">{r.name}</h3>
          <RatingPill value={r.rating} />
        </div>
        <p className="text-xs text-ink-600 truncate mt-0.5">{r.cuisine}</p>
        <div className="flex items-center gap-2 text-xs text-ink-600 mt-1">
          <span className="flex items-center gap-1"><MapPin size={12} /> {r.distance_km} km</span>
          <span>·</span>
          <span>{r.delivery_fee === 0 ? "Free delivery" : `${inr(r.delivery_fee)} delivery`}</span>
          <span>·</span>
          <span>{inr(r.price_for_two)} for two</span>
        </div>
      </div>
    </div>
  );
}
